<template>
  <div class="footer">
    <a-row style="padding-right: 10px;" class="public-width">
      <a-col :span="3" v-for="item in lits" :key="item.path">
        <div class="footer-theme">{{item.name}}</div>
        <div>
          <router-link class="footer-list" v-for='element in item.children' :to="element.path" :key="element.path">{{element.name}}</router-link>
        </div>
      </a-col>
      <a-col :span="3" style="text-align: center;">
        <p><img src="../../assets/imager/code_wx.png" alt=""></p>
        <p>微信公众号</p>
      </a-col>
      <a-col :span="3" style="text-align: center;">
        <p><img src="../../assets/imager/appDownload.png" alt=""></p>
        <p >好气网App</p>
      </a-col>
      <a-col :span="3">
        <p style="margin-top:40px">全国热线</p>
        <p class="footer-telephone">400-185-6919</p>
        <p>工作日：8:00-17:00</p>
      </a-col>
    </a-row>
    <div class="footer-bottom">
      <div>
        <router-link class="footer-bottom-theme" to="">平台介绍</router-link>
        <a-divider type="vertical" />
        <router-link class="footer-bottom-theme" to="">联系我们</router-link>
        <a-divider type="vertical" />
        <router-link class="footer-bottom-theme" to="">法律声明</router-link>
        <a-divider type="vertical" />
        <router-link class="footer-bottom-theme" to="">友情链接</router-link>
        <a-divider type="vertical" />
        <router-link class="footer-bottom-theme" to="">营业执照</router-link>
      </div>
      <div>
        COPYRIGHT©好气网 www.greatgas.cn 湘ICP备15010771号-1 湘B2-20150111
      </div>
    </div>    
  </div>
</template>

<script>
export default {
  name:"footer-menu",
  data() {
    return {
      lits: [
        {
          name: '账号问题',
          path: '账号问题',
          children: [
            {
              name: '注册认证',
              path: '注册认证',
            },
            {
              name: '无法登录',
              path: '无法登录',
            },
            {
              name: '修改账户信息',
              path: '修改账户信息',
            },
            {
              name: '子账号管理',
              path: '子账号管理',
            }
          ]
        },
        {
          name: '我要买气',
          path: '我要买气',
          children: [
            {
              name: '如何买气',
              path: '如何买气',
            },
            {
              name: '卸气点及发票维护',
              path: '卸气点及发票维护',
            },
            {
              name: '发布求购',
              path: '发布求购',
            },
            {
              name: '商城下单',
              path: '商城下单',
            }
          ]
        },
        {
          name: '我要卖气',
          path: '我要卖气',
          children: [
            {
              name: '如何卖气',
              path: '如何卖气',
            },
            {
              name: '维护商品',
              path: '维护商品',
            },
            {
              name: '商品挂牌',
              path: '商品挂牌',
            },
            {
              name: '求购报价',
              path: '求购报价',
            }
          ]
        },
        {
          name: '我是承运商',
          path: '我是承运商',
          children: [
            {
              name: '进入通道',
              path: '进入通道',
            },
            {
              name: '如何接单',
              path: '如何接单',
            },
            {
              name: '维护基础信息',
              path: '维护基础信息',
            },
            {
              name: '上报运力计划',
              path: '上报运力计划',
            }
          ]
        },
        {
          name: '交易指南',
          path: '交易指南',
          children: [
            {
              name: '交割登记',
              path: '交割登记',
            },
            {
              name: '确认结算',
              path: '确认结算',
            },
            {
              name: '完成结算',
              path: '完成结算',
            },
            {
              name: '订单变更',
              path: '订单变更',
            }
          ]
        }
      ]
    };
  },
}
</script>

<style lang="less" scope>
  @import "./index.less";
</style>
